// App.js
import React, { useContext } from 'react';
import './styles.css';
import { Dashboard } from './Components/Dashboard';
import { ThemeContext } from './Context/ThemeContextProvider';

export default function App() {
  // const { isDarkTheme } = useContext(ThemeContext);
  // console.log(isDarkTheme);
  return (
    <div>
      <Dashboard />
    </div>
  );
}
